import Background from '../../background';

export default {
    props: {
        theme: {
            type: String
        },
        absolute: {
            type: Boolean
            ,default: false,
        },
    },
    mounted() {
        this.background = new Background(this.$el, {
            theme: this.theme
        })
    },
    destroy() {
        this.background?.destroy()
    },
    template: `
        <div class="c-background" :class="{ '-absolute' : absolute }">
            <canvas></canvas>
        </div>
    `,
}
